import { useAppDispatch, useAppSelector } from '../../../../store/hooks/StoreHooks';
import useCollapseFacade from '../../../../facade/collapse.Facade';
import Accordion from '../../../common/accordion';
import { RootState } from '../../../../store/ConfigureStore';
import Select from '../../../common/select';
import { useSurfaceEquipmentFacade } from '../../../../facade/calculation/calculation-output/surfaceEquipment.facade';
import useCalculationFacade from '../../../../facade/calculation/calculation.facade';

const Transformer = () => {

  const transformer = useAppSelector((state: RootState) => state.surfaceEquipment?.Transformer);

  const { updateTransformersCollapse } = useCollapseFacade();
  const { transformersCollapse } = useAppSelector(
    (state) => state?.collapse
  );

  const {
    updateSelectedTransformer
  } = useSurfaceEquipmentFacade();
  const { updateMotorLoadFrequency, updateSchematicEquipmentData } = useCalculationFacade();

  const selectedTransformer = useAppSelector((state: RootState) => state.surfaceEquipment?.SelectedTransformer);
  const setSelectedTransformer = (transformer: any) => {
    updateSelectedTransformer(transformer);
  };

  const handleClearTransformer = () => {
    updateSelectedTransformer([]);
    updateSchematicEquipmentData();
  };

  const handleCollapseChange = (key: boolean) => {
    updateTransformersCollapse(key);
  };

  const handleChangeTransformer = async (option: any) => {
    const selectedTransformer = option.value;
    const updatedTransformerSelcted = Array.isArray(transformer)
      ? transformer.filter((item: any) => item?.id === selectedTransformer)
      : [];
    if (updatedTransformerSelcted) {
      setSelectedTransformer(updatedTransformerSelcted);
    }
    updateSchematicEquipmentData();
    updateMotorLoadFrequency();
  }

  return (
    <Accordion
      title="Transformer"
      isOpen={transformersCollapse}
      onToggle={() => handleCollapseChange(!transformersCollapse)}
      content={<div className="px-[8px] py-[16px]">
        <div className="flex items-center p-2">
          <Select
            options={transformer
              .map((transformer: any) => ({
                label: transformer?.transformers,
                value: transformer?.id,
              }))}
            onChange={handleChangeTransformer}
            placeholder="Select Transformer"
            onClear={handleClearTransformer}
            selectedValue={selectedTransformer?.id?.toString()}
            name="transformer"
            showCloseIcon={true}
            padding="px-[16px] py-[10px]"
            fontSize="14px"
            className="w-full"
          />
        </div>
      </div>}
    />
  );
}

export default Transformer